import {twJoin} from "tailwind-merge";

/* Direct port of growthjockey--website/app/components/molecules/customMarquee.tsx.
 * Two duplicated `<ul>` siblings inside the `.marquee` container animate
 * scroll keyframes in lockstep, when the first translates off-screen the
 * second is already in position, producing seamless infinite scroll. The
 * `.reverse` modifier flips animation-direction so leftToRight = travels
 * left-to-right (i.e. earlier items keep appearing from the left edge). */

export enum HorizontalScrollDirection {
    leftToRight = "ltr",
    rightToLeft = "rtl",
}

export function CustomMarquee({
    marqueeElements,
    className,
    scrollDirection,
    animationDuration,
}: {
    marqueeElements: React.ReactNode;
    className?: string;
    scrollDirection: HorizontalScrollDirection;
    animationDuration: number;
}) {
    const animation = `scroll ${animationDuration}s linear infinite`;
    return (
        <div className="w-full">
            <div className={twJoin("marquee", scrollDirection === HorizontalScrollDirection.leftToRight ? "reverse" : undefined, className)}>
                <ul
                    className="marquee-content"
                    style={{animation}}
                >
                    {marqueeElements}
                </ul>
                <ul
                    className="marquee-content"
                    aria-hidden="true"
                    style={{animation}}
                >
                    {marqueeElements}
                </ul>
            </div>
        </div>
    );
}
